import PropertyDetail from './PropertyDetail';

/**
 * PropertyDetailPage - Page wrapper for the Property detail view
 * 
 * All necessary providers (Customer, Services, Business, Jobs, Properties)
 * are provided at the route level in App.tsx
 */
export default function PropertyDetailPage() {
  return <PropertyDetail />;
};
